import styled from 'styled-components';

const Search_Style = styled.div``;

export default Search_Style;
